import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { ServiceProviderService } from '../Service/Service-providers/service-provider.service';
import { FormStateService } from '../module/service-provider/add-sp-new-component/form-state.service';
import { ServiceDistributorStatusComponent } from './service-distributor-status/service-distributor-status.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccessType, CreatorAccessType } from '../Constants/user-roles.enum';

@Component({
  selector: 'app-service-distributor',
  templateUrl: './service-distributor.component.html',
  styleUrl: './service-distributor.component.scss'
})
export class ServiceDistributorComponent {

  showModal = false;
  showPage = true;
  submittedCount: number = 0;
  inReviewCount: number = 0;
  approvedCount: number = 0;
  rejectedCount: number = 0;
  disabledCount: number = 0;
  ref: DynamicDialogRef | undefined;
  activeIndex: number = 0;

  status!: number;

  display: boolean = false;
  canShowAddDistributorButton: boolean = false;

  @ViewChild('submittedTab') submittedTab!: ServiceDistributorStatusComponent;
  @ViewChild('inReviewTab') inReviewTab!: ServiceDistributorStatusComponent;
  @ViewChild('approvedTab') approvedTab!: ServiceDistributorStatusComponent;
  @ViewChild('rejectedTab') rejectedTab!: ServiceDistributorStatusComponent;

  constructor(
    public dialogService: DialogService,
    public messageService: MessageService,
    private cdr: ChangeDetectorRef,
    private api: ServiceProviderService,
    private formStateService1: FormStateService,
    private route: ActivatedRoute,
    private router: Router
  ) { }
  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    this.canShowAddDistributorButton = this.checkCanShowAddButton(user);
    this.route.url.subscribe((segments) => {
      const path = segments.map(seg => seg.path).join('/');
      if (path === 'add') {
        this.openModal();
      }
    });
    this.fetchInitialData();
    this.cdr.detectChanges();
  }

  private checkCanShowAddButton(user: any): boolean {
    return (
      (user.accessType === AccessType.ServiceAdvisor && user.creatorUserAccessType === CreatorAccessType.SuperAdmin) ||
      user.accessType === AccessType.SuperAdmin
    );
  }

  openModal() {
    this.router.navigate(['add-distributor-partner'],
      { relativeTo: this.route });
    this.showModal = true
  }

  fetchInitialData(): void {
    const params = { status: this.activeIndex + 1 };
    this.api.getDistributorsList(params).subscribe((res: any) => {
      // Update counts for all tabs
      this.submittedCount = res.totalSubmittedRecord;
      this.inReviewCount = res.totalInReviewedRecord;
      this.approvedCount = res.totalApprovedRecord;
      this.rejectedCount = res.totalRejectedRecord;
      this.disabledCount = res.totalDisabledRecord;

      this.loadTabData(this.activeIndex, res.result.data, res.result.recordsFiltered);
      this.cdr.detectChanges();
    });
  }
  onTabChange(event: any) {
    const selectedIndex = event.index;
    this.activeIndex = selectedIndex;
    this.fetchTabData(selectedIndex);
    this.cdr.detectChanges();
  }
  fetchTabData(index: number) {
    const params = { status: index + 1 };

    this.api.getDistributorsList(params).subscribe((res: any) => {
      this.loadTabData(index, res.result.data, res.result.recordsFiltered);
      this.cdr.detectChanges();
    });
  }
  loadTabData(index: number, data: any[], totalRecords: number) {
    switch (index) {
      case 0:
        this.submittedTab.setData(data, totalRecords);
        break;
      case 1:
        this.inReviewTab.setData(data, totalRecords);
        break;
      case 2:
        this.approvedTab.setData(data, totalRecords);
        break;
      case 3:
        this.rejectedTab.setData(data, totalRecords);
        break;
      default:
        break;
    }
  }
  showAddSPPage() {
    this.showModal = true;
    this.showPage = false;
  }
  showModalW() {
    this.showModal = false
    this.router.navigate(['./'], { relativeTo: this.route });
    this.fetchInitialData();
  }
  updateListOnOwnerSuccess(): void {
    this.fetchInitialData();
    this.fetchTabData(this.activeIndex);
    this.showModal = false;
    this.cdr.detectChanges();
  }
}
